const ARTICLE_TYPES = {
  APP: 'APP',
  BOOKMARK: 'BOOKMARK',
  DAILY_NEWS: 'DAILY_NEWS',
  EMAG: 'EMAG',
  FICTION: 'FICTION',
  INFO: 'INFO',
  QUIZ: 'QUIZ',
  OTHER: 'OTHER',
};

const ARTICLE_TYPES_LABELS = {
  APP: 'Application',
  ARTICLE: 'Article',
  BOOKMARK: 'Lien',
  DAILY_NEWS: 'Article',
  EMAG: 'Magazine',
  FICTION: 'Fiction',
  INFO: 'Application',
  QUIZ: 'Quiz',
  OTHER: 'Autre',
};

const CONTENT_PUBLICATION_STATES = {
  DEFAULT: 'DEFAULT',
  PREVIEW: 'PREVIEW',
  PUBLISHED: 'PUBLISHED',
};

const CONTENT_TYPES = {
  AD: 'AD',
  ALMANACH: 'ALMANACH',
  ANSWER: 'ANSWER',
  ARTICLE: 'ARTICLE',
  DAILY_NEWS: 'DAILY_NEWS',
  EMAG: 'EMAG',
  FICTION: 'FICTION',
  GOOD_DEAL: 'GOOD_DEAL',
  HOROSCOPE: 'HOROSCOPE',
  INFO: 'INFO',
  QUIZ: 'QUIZ',
  RAW: 'RAW',
  VIDEO: 'VIDEO',
};

const CONTENT_TYPES_LABELS = {
  AD: 'Publicité',
  ALMANACH: 'Almanach',
  ANSWER: 'Réponse',
  ARTICLE: 'Article',
  DAILY_NEWS: 'Article',
  EMAG: 'Emag',
  FICTION: 'Fiction',
  GOOD_DEAL: 'Bon plan',
  HOROSCOPE: 'Horoscope',
  INFO: 'Application recommandée',
  INTERNAL_APP: 'Application',
  NOTIFICATION: 'Notification',
  QUIZ: 'Quiz',
  RAW: 'Contenu',
  VIDEO: 'Video',
};

const CONTENT_SUBTYPES = {
  ARTICLE: 'ARTICLE',
  OPTIONAL: 'OPTIONAL',
  QUOTE: 'QUOTE',
};

const SG_DOCUMENT_TYPES = {
  SGDocument: 'SGDocument',
  SGContent: 'SGContent',
};

const GOOD_DEAL_LABELS = {
  FORM: 'Formulaire',
  LINK: 'Lien',
  TEXT: 'Texte',
  ACTIVATION_SPACE: "Activation d'espace partenaire",
};

const GOOD_DEAL_TYPES = {
  Formulaire: 'FORM',
  Lien: 'LINK',
  Texte: 'TEXT',
  "Activation d'espace partenaire": 'ACTIVATION_SPACE',
};

const STATISTIC_PERIODS = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year',
  RANGE: 'range',
};

const STATISTIC_PERIODS_LABELS = {
  day: 'jour',
  week: 'semaine',
  month: 'mois',
  year: 'an',
};

const STATISTIC_METRICS = {
  UNIQUE_VISITOR: { label: 'Visiteurs uniques', value: 'nb_uniq_visitors' },
  NUMERO_CONTRAT_CUSTOM_DIMENSION: {
    label: 'Visiteurs uniques',
    value: 'nb_uniq_customdimension_customdimension2',
  },
  VISITS: { label: 'Consultations', value: 'nb_visits' },
};

const TABLET_RESOLUTIONS = {
  HEIGHT: 1200,
  WIDTH: 1920,
};

const ZODIAC_SIGNS = [
  { name: 'belier', title: 'Bélier' },
  { name: 'taureau', title: 'Taureau' },
  { name: 'gemeaux', title: 'Gémeaux' },
  { name: 'cancer', title: 'Cancer' },
  { name: 'lion', title: 'Lion' },
  { name: 'vierge', title: 'Vierge' },
  { name: 'balance', title: 'Balance' },
  { name: 'scorpion', title: 'Scorpion' },
  { name: 'sagittaire', title: 'Sagittaire' },
  { name: 'capricorne', title: 'Capricorne' },
  { name: 'verseau', title: 'Verseau' },
  { name: 'poisson', title: 'Poissons' },
];

const NOTIFICATION_DURATIONS = {
  DAILY_NEWS: 3,
  EMAG: 30,
  QUIZ: 7,
  VIDEO: 8,
};

const EMAG_COVER = {
  height: 887,
  width: 700,
};

export {
  ARTICLE_TYPES,
  ARTICLE_TYPES_LABELS,
  CONTENT_PUBLICATION_STATES,
  CONTENT_SUBTYPES,
  CONTENT_TYPES,
  CONTENT_TYPES_LABELS,
  EMAG_COVER,
  GOOD_DEAL_LABELS,
  GOOD_DEAL_TYPES,
  NOTIFICATION_DURATIONS,
  SG_DOCUMENT_TYPES,
  STATISTIC_PERIODS,
  STATISTIC_PERIODS_LABELS,
  STATISTIC_METRICS,
  TABLET_RESOLUTIONS,
  ZODIAC_SIGNS,
};
